import { geodata } from './geodata';

export const countryNames = geodata.objects.countries1.geometries.filter(x => x.properties["Alpha-2"])
  .map(c => c.properties.name)
  .sort((a, b) => {
    if (a === "United States of America") return -1;
    if (b === "United States of America") return 1;

    return a.localeCompare(b);
  });